import React from "react";
import { withRouter } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import HeaderContent from "../../components/layout/components/HeaderContent";
import TotalNoOfAssignmentsComponent from "./components/TotalNoOfAssignmentsComponent";

const TotalNoOfAssignments = () => {
  const breadcrumb = [
    { link: "/totalNoOfAssignments", title: "Total No of Assignments" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Total No of Assignments"
      />

      <Card>
        <CardContent>
          <TotalNoOfAssignmentsComponent />
        </CardContent>
      </Card>
    </>
  );
};

export default withRouter(TotalNoOfAssignments);
